<template>
  <div class="fado-houses">
    <navbar />

    <div class="page-intro page-intro--v4 d-flex justify-content-center align-items-center">
      <h1 class="page-intro__title">Noite de Fado</h1>
    </div>

    <b-container class="mb-5">
      <h3 class="page-heading">Veja as opções disponíveis</h3>

      <b-row>
        <b-col cols="12" md="6" lg="4" v-for="data in options.experiences" v-bind:key="data.id" class="mb-4">
          <Experience v-bind:image="data.image" v-bind:name="data.name" v-bind:description="data.description" v-bind:address="data.address" />
        </b-col>
      </b-row>
    </b-container>

    <Footer />
  </div>
</template>

<script>
  import Navbar from './home/sections/Navbar.vue'
  import Experience from '@/components/Experience.vue'
  import Fado from '@/data/fado.json'
  import Footer from '@/components/Footer.vue'

  export default {
    name: 'Fado',
    title: 'Noite de Fado',
    data() {
      return { options: { experiences: Fado } }
    },
    components: {
      Navbar,
      Experience,
      Footer
    }
  }
</script>